module.exports = __webpack_public_path__ + "static/media/PH1.3f09fa97.jpeg";